(() => {
  if (!document.querySelector('.cv-hero')) return;
  let scheduled = false;
  const update = () => {
    document.body.classList.toggle('nv-clean-scrolled', window.scrollY > 64);
    scheduled = false;
  };
  window.addEventListener('scroll', () => {
    if (!scheduled) {
      scheduled = true;
      window.requestAnimationFrame(update);
    }
  }, { passive: true });
  update();
})();

(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const enhanced = new WeakSet();
  function setup(root) {
    for (const hero of root.querySelectorAll('.cv-hero')) {
      if (enhanced.has(hero)) continue;
      const pair = hero.querySelector('.cv-hero-pair');
      if (!pair) continue;
      enhanced.add(hero);
      let frame = 0;
      const reset = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        pair.style.removeProperty('--nv-motion-x');
        pair.style.removeProperty('--nv-motion-y');
      };
      hero.addEventListener('pointermove', event => {
        if (reduced.matches || !fine.matches || event.pointerType !== 'mouse') return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          frame = 0;
          const box = hero.getBoundingClientRect();
          if (!box.width || !box.height) return;
          const x = (event.clientX - box.left) / box.width - .5;
          const y = (event.clientY - box.top) / box.height - .5;
          pair.style.setProperty('--nv-motion-x', (-y * 12).toFixed(2) + 'deg');
          pair.style.setProperty('--nv-motion-y', (x * 20).toFixed(2) + 'deg');
        });
      }, { passive: true });
      hero.addEventListener('pointerleave', reset);
      hero.addEventListener('pointercancel', reset);
    }

  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = null;
  let hero, story;
  const clamp = (x, lo, hi) => Math.max(lo, Math.min(hi, x));
  function update() {
    frame = null;
    if (reduced.matches) return;
    const h = hero?.getBoundingClientRect();
    const s = story?.getBoundingClientRect();
    if (h?.height && h.bottom > 0 && h.top < innerHeight) {
      const progress = clamp(-h.top / h.height, 0, 1);
      hero.style.setProperty('--nv-scroll-forest', (progress * Math.min(64, h.height * .065)).toFixed(1) + 'px');
      hero.style.setProperty('--nv-scroll-bottles', (-progress * 34).toFixed(1) + 'px');
    }
    if (s?.height && s.bottom > 0 && s.top < innerHeight) {
      const progress = clamp((innerHeight - s.top) / (innerHeight + s.height), 0, 1);
      story.style.setProperty('--nv-scroll-story', ((progress - .5) * Math.min(80, s.height * .14)).toFixed(1) + 'px');
    }
  }
  function schedule() {
    if (frame === null && !reduced.matches) frame = requestAnimationFrame(update);
  }
  function sync() {
    hero = document.querySelector('.cv-hero');
    story = document.querySelector('.cv-story-image');
    schedule();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  reduced.addEventListener?.('change', schedule);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', sync);
  sync();
})();

(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const narrow = matchMedia('(max-width: 760px)');
  let frame = null, tours = [];
  const clamp = (x, a, b) => Math.min(b, Math.max(a, x));
  function draw() {
    frame = null;
    if (reduced.matches) return;
    for (const tour of tours) {
      const box = tour.root.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) continue;
      const stage = tour.stage.getBoundingClientRect();
      const line = narrow.matches ? clamp(stage.bottom + 100, 0, innerHeight - 1) : stage.top + stage.height * .53;
      const boxes = tour.chapters.map(el => el.getBoundingClientRect());
      let selected = boxes.findIndex(rect => rect.bottom > line);
      if (selected < 0) selected = boxes.length - 1;
      const current = tour.bottles.get(tour.chapters[selected].dataset.tourProduct);
      if (!current) continue;
      if (tour.current !== current) {
        tour.current?.classList.remove('is-current');
        current.classList.add('is-current');
        tour.current = current;
      }
      const rect = boxes[selected];
      const progress = clamp((line - rect.top) / Math.max(rect.height, 1), 0, 1);
      current.style.setProperty('--nv-tour-travel', ((.5 - progress) * 44).toFixed(1) + 'px');
    }
  }
  function schedule() {
    if (frame === null && !reduced.matches && tours.length) frame = requestAnimationFrame(draw);
  }
  function init() {
    for (const t of tours) {
      t.root.classList.remove('is-ready');
      t.current?.classList.remove('is-current');
    }
    tours = [];
    if (reduced.matches) return;
    for (const root of document.querySelectorAll('[data-nv-tour]')) {
      const stage = root.querySelector('.nv-tour-stage');
      const chapters = [...root.querySelectorAll('[data-tour-product]')];
      const bottles = new Map([...root.querySelectorAll('[data-tour-bottle]')].map(el => [el.dataset.tourBottle, el]));
      if (!stage || !chapters.length || chapters.some(el => !bottles.has(el.dataset.tourProduct))) continue;
      const current = bottles.get(chapters[0].dataset.tourProduct);
      current.classList.add('is-current');
      root.classList.add('is-ready');
      tours.push({root, stage, chapters, bottles, current});
    }
    schedule();
  }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  reduced.addEventListener?.('change', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
  init();
})();

(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width:760px)');
  const clamp = (n, a=0, b=1) => Math.max(a, Math.min(b,n));
  const smooth = n => {const t=clamp(n);return t*t*(3-2*t);};
  let frame = null, scenes = [], forest;
  function draw(){
    frame=null;
    if(reduced.matches)return;
    const backdrop=clamp(scrollY/Math.max(1,document.documentElement.scrollHeight-innerHeight));
    forest?.style.setProperty('--nv-forest-y', ((backdrop-.5)*innerHeight*.12).toFixed(1)+'px');
    forest?.style.setProperty('--nv-forest-scale', (1+backdrop*.18).toFixed(3));
    for(const scene of scenes){
      const box=scene.root.getBoundingClientRect();
      if(box.bottom<0||box.top>innerHeight)continue;
      const rect=scene.hero.getBoundingClientRect();
      const clock=clamp(-box.top/Math.max(1,box.height-rect.height))*(scene.groups.length+.36);
      // Each chapter blends from the preceding pose, even during a fast scroll.
      const intro=1-smooth((clock-.08)/.64);
      const rowWidth=mobile.matches?rect.width*.90:Math.min(rect.width*.49,620);
      const centerY=mobile.matches?(rect.height<650?.36:.40):.51;
      scene.root.style.setProperty('--nv-intro',intro.toFixed(3));
      scene.root.style.setProperty('--nv-intro-vis',intro<.01?'hidden':'visible');
      // Use final-size image boxes so the browser samples the originals directly.
      const dpr=Math.max(1,window.devicePixelRatio||1);
      const snap=n=>Math.round(n*dpr)/dpr;
      const slots=scene.groups.map(g=>g.products.map(p=>p.slot.getBoundingClientRect()));
      for(const [groupIndex,g] of scene.groups.entries()){
        const first=groupIndex===0,last=groupIndex===scene.groups.length-1;
        const entryStart=first?.04:groupIndex-.02;
        const exitStart=groupIndex+.96;
        const detail=smooth((clock-entryStart-(first?.37:.43))/.32)*(last?1:1-smooth((clock-exitStart)/.39));
        const hidden=detail>.01?'false':'true';
        if(g.info.getAttribute('aria-hidden')!==hidden)g.info.setAttribute('aria-hidden',hidden);
        if(hidden==='false')g.info.style.setProperty('--nv-detail',detail.toFixed(3));
        for(const [index,p] of g.products.entries()){
          const slot=slots[groupIndex][index];
          const roll=g.format==='roll-on';
          const gridHeight=Math.min(slot.height*(roll?.84:.97),slot.width*.97/p.ratio);
          const featureHeight=Math.min(rect.height*(mobile.matches?(roll?.29:.34):(roll?.39:.46)),rowWidth/g.products.length*.83/p.ratio);
          const x=rect.left+rect.width*.5+((index+.5)/g.products.length-.5)*rowWidth*scene.direction-(slot.left+slot.width*.5);
          const y=rect.top+rect.height*centerY-(slot.top+slot.height*.5);
          const delay=index*.038;
          const enter=smooth((clock-entryStart-delay)/(first?.66:.71));
          const leave=last?0:smooth((clock-exitStart-delay)/.68);
          const featured=first||clock>=entryStart;
          const fadeIn=first?1:smooth((clock-entryStart-delay)/.47);
          const opacity=featured?fadeIn*(1-leave):1-smooth((clock-.10-delay)/.58);
          const startX=first?0:scene.direction*rect.width*(mobile.matches?.09:.14);
          const startY=first?0:rect.height*.10;
          const arc=Math.sin(enter*Math.PI)*rect.height*(mobile.matches?.025:.042);
          const px=featured?startX*(1-enter)+x*enter-scene.direction*rect.width*.24*leave:scene.direction*rect.width*.17*(1-opacity);
          const py=featured?startY*(1-enter)+y*enter-arc-rect.height*.12*leave:rect.height*.035*(1-opacity);
          const height=snap(featured?gridHeight+(featureHeight-gridHeight)*enter:gridHeight);
          const width=snap(height*p.ratio);
          const left=snap(slot.left+slot.width*.5+px-width*.5)-slot.left;
          const top=snap(slot.top+slot.height*.5+py-height*.5)-slot.top;
          const style=p.link.style;
          style.opacity=opacity.toFixed(3);
          style.visibility=opacity>.005?'visible':'hidden';
          style.left=left+'px';
          style.top=top+'px';
          style.width=width+'px';
          style.height=height+'px';
          p.slot.style.zIndex=featured&&enter>.1?'2':'';
        }
      }
    }
  }
  function schedule(){if(frame===null&&!reduced.matches)frame=requestAnimationFrame(draw);}
  function init(){
    for(const s of scenes){
      s.root.classList.remove('is-running');s.root.removeAttribute('style');
      for(const g of s.groups){g.info.setAttribute('aria-hidden','true');for(const p of g.products){p.link.removeAttribute('style');p.slot.removeAttribute('style');}}
    }
    scenes=[];
    forest=document.querySelector('.nv-cinema-forest');
    if(reduced.matches)return;
    for(const root of document.querySelectorAll('[data-nv-cinema]')){
      const hero=root.querySelector('.cv-hero');
      const details=new Map([...root.querySelectorAll('[data-cinema-detail]')].map(el=>[el.dataset.cinemaDetail,el]));
      const products=[...root.querySelectorAll('[data-cinema-slot]')].map(slot=>({slot,link:slot.querySelector('.nv-cinema-item'),photo:slot.querySelector('.nv-photo')})).filter(p=>p.link&&p.photo).map(p=>{
        const [w,h]=getComputedStyle(p.photo).aspectRatio.split('/').map(Number);
        return {...p,ratio:w>0&&h>0?w/h:1/3};
      });
      const groups=['spray','roll-on'].map(format=>({format,info:details.get(format),products:products.filter(p=>p.slot.dataset.cinemaFormat===format)})).filter(g=>g.info&&g.products.length);
      if(!hero||!groups.length)continue;
      root.style.setProperty('--nv-cinema-run',(groups.length*82+24)+'svh');
      root.classList.add('is-running');
      const nextSection=root.closest('.nv-cinema-home')?.querySelector('#scents');
      scenes.push({root,hero,groups,nextSection,direction:getComputedStyle(root).direction==='rtl'?-1:1});
    }
    schedule();
  }
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  reduced.addEventListener?.('change',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(init));

  // One deliberate gesture advances one chapter; normal scrolling resumes at either end.
  let lastWheel=-Infinity, handedOffUntil=0, handoff=0, glideTarget=0, touch=null;
  function stepTarget(direction){
    if(reduced.matches)return null;
    for(const scene of scenes){
      const box=scene.root.getBoundingClientRect();
      const travel=box.height-scene.hero.offsetHeight;
      if(box.top>2||travel<1||-box.top>travel+2)continue;
      const count=scene.groups.length;
      const clock=clamp(-box.top/travel)*(count+.36);
      const current=clock<.36?-1:clamp(Math.floor(clock-.36),0,count-1);
      const next=current+direction;
      if(next>=count){
        const header=document.querySelector('.nv-header');
        const top=scene.nextSection?scrollY+scene.nextSection.getBoundingClientRect().top-(header?.getBoundingClientRect().height||0)-12:scrollY+box.bottom;
        return {top:Math.max(0,top),exit:true};
      }
      if(next< -1||next===current)return null;
      return {top:Math.max(0,scrollY+box.top+(next<0?0:(next+.86)/(count+.36)*travel)),exit:false};
    }
    return null;
  }
  function stopHandoff(){
    if(!handoff)return;
    cancelAnimationFrame(handoff);
    handoff=0;
  }
  function advance({top,exit}){
    glideTarget=top;
    const startY=scrollY,start=performance.now(),duration=exit?1100:1250;
    function glide(now){
      const p=reduced.matches?1:clamp((now-start)/duration);
      const eased=p*p*p*(p*(p*6-15)+10);
      scrollTo({top:startY+(top-startY)*eased,behavior:'instant'});
      if(p<1){handoff=requestAnimationFrame(glide);return;}
      handoff=0;
      handedOffUntil=now+200;
    }
    handoff=requestAnimationFrame(glide);
  }
  window.addEventListener('pointerdown',event=>{if(event.pointerType!=='touch')stopHandoff();},{passive:true});
  window.addEventListener('keydown',stopHandoff);
  function isControl(el){return el instanceof Element&&!!el.closest('.nv-header, input, select, textarea, button, [contenteditable]');}
  window.addEventListener('wheel',event=>{
    if(reduced.matches||event.ctrlKey||isControl(event.target)||Math.abs(event.deltaY)<=Math.abs(event.deltaX)||!event.deltaY)return;
    const now=performance.now(),continued=now-lastWheel<135;
    lastWheel=now;
    if(handoff){
      if(!continued&&(event.deltaY<0||Math.abs(scrollY-glideTarget)<=4))stopHandoff();
      else {event.preventDefault();return;}
    }
    const target=stepTarget(Math.sign(event.deltaY));
    if(continued&&(target!==null||now<handedOffUntil)){event.preventDefault();return;}
    if(target===null)return;
    event.preventDefault();
    advance(target);
  },{passive:false});
  document.addEventListener('touchstart',event=>{
    touch=null;
    if(event.touches.length!==1||isControl(event.target)||!(event.target instanceof Element)||!event.target.closest('.nv-cinema.is-running'))return;
    const p=event.touches[0];touch={x:p.clientX,y:p.clientY,target:null};
  },{passive:true});
  document.addEventListener('touchmove',event=>{
    if(handoff&&event.touches.length===1){if(event.cancelable)event.preventDefault();return;}
    if(!touch||event.touches.length!==1){touch=null;return;}
    const p=event.touches[0],dy=touch.y-p.clientY;
    if(Math.abs(dy)<9||Math.abs(dy)<=Math.abs(touch.x-p.clientX))return;
    const target=stepTarget(Math.sign(dy));
    if(target===null||!event.cancelable)return;
    event.preventDefault();
    touch.target=target;
  },{passive:false});
  document.addEventListener('touchend',event=>{
    if(touch?.target!==null&&touch?.target!==undefined&&!handoff&&Math.abs(touch.y-(event.changedTouches[0]?.clientY??touch.y))>24)advance(touch.target);
    touch=null;
  },{passive:true});
  document.addEventListener('touchcancel',()=>{touch=null;},{passive:true});
  init();
})();

(() => {
  if(!('IntersectionObserver' in window)||!Element.prototype.animate)return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const fine=matchMedia('(hover:hover) and (pointer:fine)');
  const cards='.cv-scent-card,.cv-collection .nv-card,.cv-bundles .nv-bundle,.cv-formats-grid article';
  const features='.cv-scents .cv-heading,.cv-story-copy,.cv-collection .cv-heading,.cv-bundles .cv-heading,.cv-faq > div,.cv-newsletter-inner > div';
  const ready=new WeakSet(), running=new Set();
  const observer=new IntersectionObserver(entries=>{
    for(const {target,isIntersecting} of entries){
      if(!isIntersecting)continue;
      observer.unobserve(target);
      if(reduce.matches||target.matches(':focus-within'))continue;
      const card=target.classList.contains('nv-depth-card');
      const index=card?Array.prototype.indexOf.call(target.parentElement.children,target):0;
      const angle=index%2===0?-8:8;
      const animation=target.animate([
        {opacity:card?.30:.50,transform:card?'perspective(900px) translate3d(0,42px,-35px) rotateX(15deg) rotateY('+angle+'deg)':'translateY(28px)'},
        {opacity:1,transform:card?'perspective(900px) translate3d(0,0,0) rotateX(0deg) rotateY(0deg)':'translateY(0)'}
      ],{duration:card?820:690,delay:card?Math.min(index%4,3)*85:0,easing:'cubic-bezier(.2,.7,.22,1)',fill:'backwards'});
      running.add(animation);
      const done=()=>running.delete(animation);
      animation.onfinish=done;
      animation.oncancel=done;
      target.addEventListener('focusin',()=>animation.cancel(),{once:true});
    }
  },{threshold:.13});
  function setup(root){
    for(const el of root.querySelectorAll(cards+','+features)){
      if(ready.has(el))continue;
      ready.add(el);
      observer.observe(el);
      if(!el.matches(cards))continue;
      el.classList.add('nv-depth-card');
      let box=null,frame=0,x=0,y=0;
      const reset=()=>{
        cancelAnimationFrame(frame);
        frame=0;box=null;
        el.classList.remove('is-tilting');
        for(const name of ['--nv-card-x','--nv-card-y','--nv-glint-x','--nv-glint-y'])el.style.removeProperty(name);
      };
      el.addEventListener('pointermove',event=>{
        if(reduce.matches||!fine.matches||event.pointerType!=='mouse')return;
        box??=el.getBoundingClientRect();
        if(!box.width||!box.height)return;
        x=Math.min(1,Math.max(0,(event.clientX-box.left)/box.width));
        y=Math.min(1,Math.max(0,(event.clientY-box.top)/box.height));
        if(frame)return;
        frame=requestAnimationFrame(()=>{
          frame=0;
          el.classList.add('is-tilting');
          el.style.setProperty('--nv-card-x',((.5-y)*15).toFixed(2)+'deg');
          el.style.setProperty('--nv-card-y',((x-.5)*19).toFixed(2)+'deg');
          el.style.setProperty('--nv-glint-x',(x*100).toFixed(1)+'%');
          el.style.setProperty('--nv-glint-y',(y*100).toFixed(1)+'%');
        });
      },{passive:true});
      el.addEventListener('pointerleave',reset);
      el.addEventListener('pointercancel',reset);
    }
  }
  reduce.addEventListener?.('change',()=>{if(reduce.matches)for(const animation of running)animation.cancel();});
  setup(document);
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
